module.exports = __webpack_public_path__ + "img/premia_coord.00b2b21c.png";